module.exports = __webpack_public_path__ + "img/type2.4d2d2bc4.png";